import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { publicOperationMiddleware } from '../../../permissions/middlewares/publicOperationMiddleware.js';
import { resolveSearchSchoolNames } from '../server/resolveSearchSchoolNames.js';

export const searchSchoolNames = registerQuery({
  operationName: 'searchSchoolNames',
  middlewares: [publicOperationMiddleware('Oeffentliche Schulliste fuer das Anmeldeformular')],
  type: () => [String],
  params: [{ type: () => String, name: 'query' }],
  resolve: resolveSearchSchoolNames,
});
